import { I18n } from "@assets/strings";
import { useState } from "react";
import { useServices } from "@core/servicesContext";
import { createToast } from "@ui/toasts/utils";
import { useAsync } from "@utils/hooks";

export function useEmailVerification(): { sendEmail: () => Promise<void>; loading: boolean; sent: boolean } {
	const { authService } = useServices();

	const { run, loading } = useAsync(async () => {
		await authService.sendVerifyEmail();
		setSent(true);
		createToast(I18n.t("success"), I18n.t("onboarding.verify.sent"), "success");
	}, []);
	const [sent, setSent] = useState(false);

	return { sendEmail: run, loading, sent };
}
